import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios';
import VueAxios from 'vue-axios'
// import ReactiveStorage from "vue-reactive-localstorage";
import VModal from 'vue-js-modal';
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue';
import Notifications from 'vue-notification'
import Autocomplete from 'vue2-autocomplete-js'
import VueFileAgent from 'vue-file-agent';
import VueFileAgentStyles from 'vue-file-agent/dist/vue-file-agent.css';
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import HighchartsVue from "highcharts-vue";
import titleMixin from './mixins/titleMixin'
import VueGoogleApi from 'vue-google-api'
import GAuth from 'vue-google-oauth2'
import {helpers} from './helpers.js'
import { getDefaultRouteByRole } from '@/helpers/auth';

Vue.prototype.$helpers = helpers

const gauthOption = {
  clientId: '168832827285-naljg669rvsa38m9vpum37vkh421add8.apps.googleusercontent.com',
  scope: 'https://www.googleapis.com/auth/adwords',
  // prompt: 'select_account'
}
Vue.use(GAuth, gauthOption)


const config = {
  apiKey: 'AIzaSyDlhftQvXyMxmAekO5dvCkhqew9shpg-vk',
  clientId: '168832827285-lakb97ol3ojc7quhha3euvkk723c6rv3.apps.googleusercontent.com',
  scope: 'https://www.googleapis.com/auth/indexing',
  discoveryDocs: []
}
Vue.use(VueGoogleApi, config)

Vue.use(HighchartsVue);
Vue.use(VueFileAgent);
Vue.mixin(titleMixin)

require('./assets/css/style.css')
require('./assets/css/icons/style.css')
require('vue2-autocomplete-js/dist/style/vue2-autocomplete.css')
require('bootstrap/dist/css/bootstrap.css')
require('bootstrap-vue/dist/bootstrap-vue.css')

// Add a request interceptor
axios.interceptors.request.use(function (config) {
  let loader = document.getElementById("loader");
  loader.style.display = 'block';

	if (localStorage.getItem('user'))
  {
    let token = localStorage.getItem('user');
		config.headers['Authorization'] = 'Bearer ' + token;
	}
    return config;
  }, function (error) {
    // Do something with request error
    return Promise.reject(error);
  }
);

// Add a response interceptor
axios.interceptors.response.use(function (response) {
    let loader = document.getElementById("loader");
    loader.style.display = 'none';
    return response;
  }, function (error) {
  if (error.response && ((error.response.status == 400) || (error.response.status == 500)))
  {
    if (error.response && error.response.data)
    {
      if (error.response.data.message){
        alert(error.response.data.message)
      }
      else{
        alert(error.response.data);
      }
    }
    else
      alert("A aparut o eroare. Va rugam incercati din nou sau contactati departamentul IT.");  
         
    let loader = document.getElementById("loader");
    loader.style.display = 'none';
  }
	if (error.response && (error.response.status == 403 || error.response.status == 401))
	{
    localStorage.removeItem("user");
    localStorage.removeItem("email");
    localStorage.removeItem("firstname");
    localStorage.removeItem("lastname");
    localStorage.removeItem("redirect");
    localStorage.removeItem("roles");
		window.location.href = '/login';
	}
	else
	  if (error.response)
		{
			Vue.notify({
			    group: 'notifications',
			    type: 'error-notification',
			    title: 'An error occured',
			    text: error.response.data.message
			  });
		}
    let loader = document.getElementById("loader");
    loader.style.display = 'none';
    return Promise.reject(error);
  }
);

Vue.use(BootstrapVue)
Vue.use(VueAxios, axios)
Vue.use(VModal);
Vue.use(Notifications)

// router.beforeEach((to, from, next) => {
//   if (from.name == 'orders'){
//     if(!confirm("Selectia de filtre aplicate se va pierde. Sunteti sigur?")){
//       return;
//     }
//   }
//   if (to.matched.some(record => record.meta.requiresAuth)) {
//     // this route requires auth, check if logged in
//     // if not, redirect to login page.
//     if (!(localStorage.getItem("user") != null && localStorage.getItem("user") != '' && localStorage.getItem("user") != 'null')) {
//       window.location.href = "/login?redirect=" + to.fullPath;
//     } else {
//       next()
//     }
//   } else {
//     next()
//   }
// })

router.beforeEach((to, from, next) => {
  if (from.name == 'orders'){
    if(!confirm("Selectia de filtre aplicate se va pierde. Sunteti sigur?")){
      return;
    }
  }
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    if (!(localStorage.getItem("user") != null && localStorage.getItem("user") != '' && localStorage.getItem("user") != 'null')) {
      window.location.href = "/login?redirect=" + to.fullPath;
    } 
    
    let userRoles = [];

    try {
      userRoles = JSON.parse(localStorage.getItem('roles') || '[]')
        .map(r => String(r).toLowerCase());
    }
    catch {
      userRoles = [];
    }

    const allowedRoles = to.meta.roles || [];

    if (allowedRoles.length > 0) {

      const hasAccess =
        // userRoles.includes('superadmin') || 
        // userRoles.includes('admin') ||
        allowedRoles.some(role =>
          userRoles.includes(role.toLowerCase())
        );
      if (!hasAccess) {
        return next(getDefaultRouteByRole(userRoles));
      }
    }

    next();
  } else {
    next()
  }
})

// This is a global mixin, it is applied to every vue instance
Vue.mixin({
  data: function() {
    return {
      get baseUrl() {
        return 'https://api.bookzone.ro';
        //return 'http://devapi.bkz.ro/';
        //return 'http://localhost:5000';
      },
      get baseImgUrl() {
        return 'https://api.bookzone.ro'
        //return 'http://localhost:5000';
      },
      get baseAdminUrl() {
        return 'https://api.bookzone.ro/admin/'
        //return 'http://devapi.bkz.ro/admin/';
        //return 'http://localhost:5000/admin/';
      },
      get baseWarehouseAPIUrl() {
        return 'https://depozit-api.bookzone.ro/'
        // return 'http://localhost:5005/';
      },
      get baseDistributionAPIUrl() {
        return 'https://distribution-api.bookzone.ro/'
        // return 'http://localhost:5010/';
      },
      get baseSEOAPIUrl() {
        return 'https://seo-api.bookzone.ro/'
        // return 'http://localhost:5015/';
      },
      get baseSuppliersAPIUrl() {
        return 'https://suppliers-api.bookzone.ro/'
        // return 'http://localhost:5020/';
      },
      get baseSalesAPIUrl() {
        return 'https://sales-api.bookzone.ro/'
        // return 'http://localhost:5070/';
      },
      get baseFairsAPIUrl() {
        return 'https://fairs-api.bookzone.ro/'
        //return 'http://localhost:5080/';
      },
      get baseLibrariesAPIUrl() {
        return 'https://libraries-api.bookzone.ro/'
        // return 'http://localhost:5025/';
      },
      get getFirstName() {
        return localStorage.getItem("firstname");
      },
      get isLoggedIn() {
        return localStorage.getItem("user") != null && localStorage.getItem("user") != '' && localStorage.getItem("user") != 'null';
      },
      get baseSalesImgUrl() {
        return 'https://sales-api.bookzone.ro/assets/'
      },
      get baseEmagAPIUrl() {
        return 'https://emag-api.bookzone.ro/'
        //return 'http://localhost:5090/';
      },
      get baseAltexAPIUrl() {
        return 'https://altex-api.bookzone.ro/'
        //return 'http://localhost:5044/';
      },
    }
  }
})

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
